import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/auth-context";
import { ReactComponent as AppLoaderSvg } from "../../assets/img/app-loader.svg";
function AuthCallbackSilent() {
  const { userManager } = useAuth();
  const [error, setError] = useState(null);
  useEffect(() => {
    userManager.signinSilentCallback().catch((err) => {
      console.error("Silent Renewal Error:", err);
      setError(err.message || "Silent Renewal Error");
    });
  }, [userManager]);
  if (error) {
    return <div>Error: {error}</div>;
  }
  return <div
    className="app-loading-screen primary"
    role="status"
    aria-live="polite"
  >
    <AppLoaderSvg
      className="app-loader-svg"
      width={200}
      height={200}
      focusable="false"
    />
    <span>Loading...</span>
  </div>;
}
export default AuthCallbackSilent;